module.exports = __webpack_public_path__ + "img/icon-thanks.059aaae4.svg";